import { jsx as t, Fragment as o } from "react/jsx-runtime";
import i from "@mui/icons-material/InfoOutlined";
import { Tooltip as r, styled as e, IconButton as m } from "@mui/joy";
import l from "@mui/joy/Typography";
const n = e(m)({ padding: 2, margin: 0, minWidth: "auto", minHeight: "auto" }), a = t(i, { sx: { height: "16px", width: "16px", color: (t2) => t2.palette.neutral[500] } }), p = ({ tooltip: i2, width: e2 = "245px", icon: m2 = a }) => t(o, { children: t(r, { arrow: true, color: "neutral", title: t(l, { sx: { width: { width: e2 }, color: "neutral.100" }, level: "body-sm", children: i2 }), placement: "bottom", children: t(n, { children: m2 }) }) });
export {
  p as CustomTooltip
};
//# sourceMappingURL=CustomTooltip.js.map
